import { create } from 'zustand';

import PAEvent from "../MasterEventObjects/PAEvent";




const usePA_GlobalStore = create((set, get) => ({
    PA_GlobalObject: {
        Planning: new PAEvent(),
    },

    // UI State for the cloud icon
    isSyncing: false,
    showCloudSuccess: false,

    set_PA_GlobalObject: async (update) => {
        set((state) => {
            const newState =
                typeof update === "function" ? update(state.PA_GlobalObject) : update;
            return {
                PA_GlobalObject: { ...state.PA_GlobalObject, ...newState },
            };
        });
    },

    // 1. Call this BEFORE sending the socket message for important actions
    startSyncing: () => set({ isSyncing: true, showCloudSuccess: false }),

    // 2. Call this when the server ACK/Success arrives
    triggerSyncSuccess: () => {
        set({ isSyncing: false, showCloudSuccess: true });

        setTimeout(() => {
            set({ showCloudSuccess: false });
        }, 2000);
    },

}));

export default usePA_GlobalStore;
